<template>
  <div class="search_loading_modal" @click="close">
    <div class="search_loading_backdrop" />
    <div class="search_loading_panel" @click.stop>
      <div class="search_loading_header">
        <div class="search_loading_spacer" />
        <button
          type="button"
          class="search_loading_close"
          aria-label="Close search"
          @click="close"
        >
          x
        </button>
      </div>
      <div class="search_loading_body">{{ t("sharedUi.common.loading") }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

function close() {
  emit("close");
}

function handleKeydown(event: KeyboardEvent) {
  if (event.key === "Escape") {
    close();
  }
}

onMounted(() => {
  document.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown);
});
</script>

<style lang="scss" scoped>
.search_loading_modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.search_loading_backdrop {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: rgb(0 0 0 / 50%);
  backdrop-filter: blur(4px);
}

.search_loading_panel {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100vw - 2rem);
  height: calc(100vh - 2rem);
  overflow: hidden;
  color: var(--classic-text, inherit);
  background: var(--classic-surface, #fff);
  border-radius: 12px;
  box-shadow: 0 25px 50px rgb(0 0 0 / 25%);
}

.search_loading_header {
  display: flex;
  align-items: center;
  padding: 12px 16px 8px;
}

.search_loading_spacer {
  flex: 1;
}

.search_loading_close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-size: 18px;
  line-height: 1;
  color: var(--classic-text-muted, #6b7280);
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 8px;
}

.search_loading_close:hover {
  color: var(--classic-text, #374151);
  background: var(--classic-surface-hover, #f3f4f6);
}

.search_loading_body {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-size: 14px;
  color: var(--classic-text-muted, #6b7280);
}

@media (min-width: 640px) {
  .search_loading_panel {
    width: 840px;
    height: 80vh;
    max-height: 1100px;
  }
}
</style>
